var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiggybank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    svgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M494.422,228.578c-5.859-5.859-15.352-5.859-21.211,0s-5.859,15.352,0,21.211C478.88,255.458,482,262.987,482,271 c0,16.538-14.462,30-31,30h-0.696c-0.015-0.163,0.007-0.32-0.007-0.483c-6.18-67.639-55.095-122.173-120.108-141.493 C326.056,204.846,287.88,241,241,241c-48.657,0-88.173-38.873-89.713-87.162C131.543,133.222,104.445,121,76,121 c-4.409,0-8.599,1.934-11.44,5.303c-2.856,3.369-4.087,7.822-3.354,12.158l11.382,68.247 c-16.787,18.721-28.931,40.972-35.625,65.2C16.469,276.112,0,294.276,0,316v30c0,24.814,21.186,45,46,45 c0.688,0,1.377-0.044,2.051-0.132c0.293,0.015,0.586,0.015,0.894,0.029C59.198,410.995,73.539,428.866,91,443.295V497 c0,8.291,6.709,15,15,15h60c8.291,0,15-6.709,15-15v-17.5c5.015,0.456,9.968,1.5,15,1.5h75v16c0,8.291,6.709,15,15,15h60 c8.291,0,15-6.709,15-15v-33.988c50.801-25.917,83.815-76.013,88.984-132.012H451c33.091,0,61-26.909,61-60 C512,254.975,505.76,239.916,494.422,228.578z M106,301c-8.284,0-15-6.716-15-15c0-8.286,6.716-15,15-15s15,6.714,15,15 C121,294.284,114.284,301,106,301z M286,301h-90c-8.291,0-15-6.709-15-15c0-8.291,6.709-15,15-15h90c8.291,0,15,6.709,15,15 C301,294.291,294.291,301,286,301z",
    fill: "#bee5f6",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241,91c-33.091,0-60,26.909-60,60s26.909,60,60,60s60-26.909,60-60S274.091,91,241,91z",
    fill: "#bee5f6",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M361,0c-33.091,0-60,26.909-60,60s26.909,60,60,60s60-26.909,60-60S394.091,0,361,0z",
    fill: "#bee5f6",
    "data-original": "#000000",
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggybank);
export default __webpack_public_path__ + "static/media/piggybank.42442f40749e0c5f392078381883bbe8.svg";
export { ForwardRef as ReactComponent };